<template>
  <section class="apps-list">
    <loading :active.sync="isLoading" :can-cancel="false" :is-full-page="false"></loading>
    <header>
      <input
        v-model="searchTermData"
        v-debounce:500ms="changeSearchTerm"
        type="text"
        placeholder="Search by App"
      />
    </header>
    <ul v-if="appsList && appsList.length">
      <li v-for="app in appsList" :key="app.id">
        <div class="app-item">
          <div class="box-info">
            <div class="box-info--content">
              <div class="description">
                <h1>{{ app.name }}</h1>
                <p>{{ app.description }}</p>
              </div>
              <div class="tags">
                <span v-for="(hasCategory, i) in app.has_categories" :key="hasCategory.id">
                  {{ hasCategory.category.name }}
                  <span v-if="i <= (app.has_categories.length - 2)">/</span>
                </span>
              </div>
            </div>
            <div class="box-info--footer">
              <ul>
                <li v-if="app.hasTrail">
                  <span>Trial</span>
                  <h3>
                    Free
                    <sup></sup>
                  </h3>
                </li>
                <li v-if="app.price_pro">
                  <span>Professional</span>
                  <h3>
                    {{ app.price_pro | moneyDBtoDisplay }}
                    <sup>€</sup>
                  </h3>
                </li>
                <li v-if="app.price_pro">
                  <span>Premium</span>
                  <h3>
                    {{ app.price_premium | moneyDBtoDisplay }}
                    <sup>€</sup>
                  </h3>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div
      v-if="!isLoading && appsList && !appsList.length"
      class="empty-list-message"
    >Sorry, no apps found...</div>
    <pagination
      v-if="appsList && appsList.length"
      :data="appsData"
      @pagination-change-page="callGetList"
    >
      <span slot="prev-nav">&lt;</span>
      <span slot="next-nav">&gt;</span>
    </pagination>
  </section>
</template>

<script>
import { mapState, mapActions } from "vuex";
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";

export default {
  name: "ChennelList",
  components: {
    Loading
  },
  data() {
    return {
      searchTerm: "",
      isLoading: false
    };
  },
  computed: {
    ...mapState("apps", ["list", "appsData", "filters"]),
    searchTermData: {
      get() {
        return this.filters.term;
      },
      set(newValue) {
        this.setFilterTerm(newValue);
      }
    },
    appsList() {
      if (this.appsData && this.appsData.data.length) return this.appsData.data;

      return [];
    }
  },
  mounted() {
    this.isLoading = true;
    this.getApps().finally(() => {
      this.isLoading = false;
    });
  },
  methods: {
    ...mapActions("apps", ["getApps", "setFilterTerm"]),
    changeSearchTerm() {
      this.callGetList(1);
    },
    callGetList(page = 1) {
      this.getApps({ page: page });
    }
  }
};
</script>

<style>
.sr-only {
  display: none;
}

.empty-list-message {
  text-align: center;
  font-size: 2em;
  color: #b1b1b1;
}
</style>